import { createSelector } from 'reselect';

import { StoreType } from '@tock/shared/utils/connect';
import { filter, forEach, map, sortBy } from 'es-toolkit/compat';

const serviceOrderMapping: { [service: string]: number } = {
  BREAKFAST: 1,
  BRUNCH: 2,
  LUNCH: 3,
  DINNER: 4,
};

export default createSelector(
  (state: StoreType) => state.features.features,
  (state: StoreType) => state.services.forWeekday,
  (state: StoreType) => state.publicHours.forWeekday,
  (features, servicesByWeekday, publicHoursByWeekday) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const serviceTypesObj: any = {};
    const servicesByDay = features.PUBLIC_HOURS_BASED_SERVICE_FILTER
      ? publicHoursByWeekday
      : servicesByWeekday;
    forEach(servicesByDay, (dayServices) => {
      forEach(dayServices, (service) => {
        serviceTypesObj[service.serviceType] = true;
      });
    });
    const serviceTypes = map(serviceTypesObj, (v, k) => {
      return k;
    });
    return filter(
      sortBy(serviceTypes, (serviceType) => {
        return serviceOrderMapping[serviceType];
      })
    );
  }
);
